export default __webpack_public_path__ + "static/media/tidal-app-icon.60bd5532.png";